import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Stack from '@mui/material/Stack'
import { WatchListItem } from '@finance-lab/utils/types'
import { AdvisorSelect } from '../../components/AdvisorSelect'
import { AdvisorEntity } from 'types/AdvisorEntity'
import AdvisorApi from '../../api/AdvisorApi'

const advisorApi = new AdvisorApi()

export const AddAvisorWatchItem = ({
    onAdd,
    typeLowercase,
}: {
    onAdd: (advisor: Pick<WatchListItem, 'name' | 'id'>) => void
    typeLowercase: string
}) => {
    const { t } = useTranslation()
    const [advisors, setAdvisors] = useState<AdvisorEntity[] | null>(null)

    useEffect(() => {
        void (async () => {
            const result = await advisorApi.findAll()

            setAdvisors(result)
        })()
    }, [])

    const handleSelect = (advisor: AdvisorEntity) => {
        console.log({ advisor })
        onAdd({ id: advisor.id, name: advisor.name })
    }

    return (
        <>
            <p style={{ fontWeight: 'bold' }}>{t('pages.watchLists.addHeading', { type: typeLowercase })}</p>
            <Stack direction='row' sx={{ maxWidth: 400 }}>
                {advisors && (
                    <AdvisorSelect
                        advisors={advisors}
                        label={t('pages.watchLists.searchAdvisor')}
                        onSelect={handleSelect}
                    />
                )}
            </Stack>
        </>
    )
}
